import React from "react";
import {
  CustomDataTable
} from "../../../components/CommnTable/CustomDataTable";
import useStudentEvaluation from "./useStudentEvaluation"
import { StudentEvaluationList } from "../../../types/types";
import {Card, Box } from "@mui/material";

const StudentEvaluation = () => {
    const {columns, HandlePagination, data, limitValue} = useStudentEvaluation()
    return(  <Card
        style={{
          padding: "1rem",
          border: 0,
          boxShadow: "none",
          background: "none",
          
        }}
      >
        <Box className={"cardBoxUI"}>
          <CustomDataTable<StudentEvaluationList>
            data={data}
            columns={columns}
            tableTitle="Student Evaluation"
            rowsPerPage={limitValue}
            onPageChange={(e: any) => HandlePagination(e)}
            exportExcelShow={true}
          />
        </Box>
      </Card>)
}

export default StudentEvaluation